import axiosInstance from '../../../helpers/backend_helper';

const createAmazonBook = async (title, amazonLink, amazonLinkTwo, coverImage) => {
  try {
    const formData = new FormData();
    formData.append('name', title);
    formData.append('image', coverImage);
    formData.append('amazon_link', amazonLink);
    formData.append('amazon_link_uk', amazonLinkTwo);
    const response = await axiosInstance.post('books', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error creating Amazon book:', error);
    throw error;
  }
};

export default createAmazonBook;
